import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Brain, ArrowRight } from 'lucide-react';

const StudentDetailsPage = () => {
  const navigate = useNavigate();
  const [studentDetails, setStudentDetails] = useState({
    name: '',
    email: ''
  });

  const [testData, setTestData] = useState(null);

  useEffect(() => {
    const cachedTest = localStorage.getItem('currentTest');
    if (!cachedTest) {
      navigate('/');
      return;
    }
    setTestData(JSON.parse(cachedTest));
  }, [navigate]);

  const handleSubmit = (e) => {
    e.preventDefault();
    // Store student details for the test
    localStorage.setItem('studentDetails', JSON.stringify(studentDetails));
    // Navigate to test taking page
    navigate('/take-test');
  };

  return (
    <div className="min-h-screen bg-indigo-500 text-white">
      <header className="container mx-auto py-6 px-4">
        <div 
          className="flex items-center space-x-2 cursor-pointer hover:opacity-80 transition-opacity"
          onClick={() => navigate('/')}
        >
          <Brain className="h-8 w-8" />
          <span className="text-2xl font-bold">PMind</span>
        </div>
      </header>

      <div className="container mx-auto px-4 py-20">
        <div className="max-w-md mx-auto">
          <div className="bg-white/10 backdrop-blur-lg rounded-xl p-8">
            <h2 className="text-3xl font-bold mb-2 text-center">Cum te cheamă?</h2>
            {testData && (
              <div className="mb-6 text-center">
                <p className="text-lg font-medium">{testData.title}</p>
                <p className="text-sm text-white/70">{testData.subject.name}</p>
              </div>
            )}
            <form onSubmit={handleSubmit} className="space-y-6">
              <div className="space-y-2">
                <label className="block text-sm font-medium">Numele tău</label>
                <input
                  type="text"
                  required
                  className="w-full p-3 rounded-lg bg-white/5 border border-white/20 focus:outline-none focus:ring-2 focus:ring-yellow-400"
                  placeholder="Introdu numele complet"
                  value={studentDetails.name}
                  onChange={(e) => setStudentDetails({...studentDetails, name: e.target.value})}
                />
              </div>
              
              <div className="space-y-2">
                <label className="block text-sm font-medium">Email</label>
                <input
                  type="email"
                  required
                  className="w-full p-3 rounded-lg bg-white/5 border border-white/20 focus:outline-none focus:ring-2 focus:ring-yellow-400"
                  placeholder="Introdu emailul"
                  value={studentDetails.email}
                  onChange={(e) => setStudentDetails({...studentDetails, email: e.target.value})}
                />
              </div>

              <button
                type="submit"
                className="w-full bg-yellow-400 hover:bg-yellow-300 text-purple-900 font-bold py-3 px-6 rounded-lg flex items-center justify-center transition transform hover:scale-105"
              >
                Start Test <ArrowRight className="ml-2 h-5 w-5" />
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default StudentDetailsPage;
